
import axios from "axios";
import { store } from "store";
import { OutputBaseProps, PaginationProps } from "utils/types/API";
import { PositionItemProps } from ".";
import { loading, index, options } from "store/position";

interface ApiPositionInputProps {
    page?: number;
    pageSize?: number;
    q?: string;
}

type ApiPositionOutputProps = OutputBaseProps<{ list: PositionItemProps[]; pagination?: PaginationProps; }>;

export const apiPositionIndex = async (data: ApiPositionInputProps) => {
    store.dispatch(loading());
    const res = (await axios.get<ApiPositionOutputProps>("/api/positions", { params: data }))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(index({ data: res.data.list, pagination: res.data.pagination }));
    }
    return res;
};

export const apiPositionOptions = async (data: { q?: string; }) => {
    store.dispatch(loading());
    const res = (await axios.get<ApiPositionOutputProps>("/api/positions", { params: { ...data, fields: "id,code,name" } }))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(options({ data: res.data.list }));
    }
    return res;
};